import { render, staticRenderFns } from "./full.vue?vue&type=template&id=11619663"
import script from "./full.vue?vue&type=script&lang=js"
export * from "./full.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11619663')) {
      api.createRecord('11619663', component.options)
    } else {
      api.reload('11619663', component.options)
    }
    module.hot.accept("./full.vue?vue&type=template&id=11619663", function () {
      api.rerender('11619663', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/full.vue"
export default component.exports